module.exports = __webpack_public_path__ + "static/about-riverton-1977a53ecb49dbc073d56bcb47df4fd6.jpg";